import { BaseBreakpointConfig, createBreakpoints } from '@chakra-ui/theme-tools'

export const breakpoints: BaseBreakpointConfig = createBreakpoints({
  sm: '40em',
  md: '52em',
  lg: '64em',
  xl: '80em',
})
